module.exports = __webpack_public_path__ + "static/media/long-arrow.67ccd768.svg";